// The claim window the recovery copy has always promised, now actually enforced: both
// `recovery.items.claims-notice` and `refund-resolution.claims-notice` told the guest "within 14
// days" while nothing measured it. See ../README.md § Exception states.

// iOS `claimPeriodDays` (OrderSupportExceptionViewModel.swift). Matched rather than made
// configurable: the number is also in guest-facing copy, and drift means a screen that promises
// 14 days and enforces 7.
export const CLAIM_WINDOW_DAYS = 14

const MS_PER_DAY = 24 * 60 * 60 * 1000

/**
 * Whether an order is still inside the refund claim window, measured from ORDER PLACEMENT
 * (`createdDateTime`, epoch millis) to match iOS — whose copy says "within 14 days of delivery"
 * while its gate uses placement (see ../README.md § Exception states). Day 14 is inclusive, since
 * the other off-by-one silently denies a claim we advertised as valid. Fails open on an absent,
 * unusable, or future date: refusing support because OUR field is broken is the worse failure.
 */
export function isWithinClaimWindow(
  createdDateTime?: number | null,
  now: number = Date.now(),
  days: number = CLAIM_WINDOW_DAYS
): boolean {
  if (createdDateTime == null || !Number.isFinite(createdDateTime)) return true
  const elapsedMs = now - createdDateTime
  if (elapsedMs < 0) return true
  return elapsedMs <= days * MS_PER_DAY
}
